<template>
  <div class="voices">
    <div class="list">
      <div class="item-box" v-for="(key, index) in Object.keys(dataSource)" :key="`${index}_${key}`">
        <div
          class="voices-item"
          v-if="dataSource[key].desc.hasValue && dataSource[key].desc.value.trim() && dataSource[key].source.value"
        >
          <div class="icon" @click="handlePlay(key)">
            <img v-if="playKey !== key" src="@/assets/zs_imgs/audio-icon.png" alt="" />
            <img v-else src="@/assets/zs_imgs/audio-active-icon.png" alt="" />
          </div>

          <div class="info">
            <div class="name">
              {{ dataSource[key].label.value }}
            </div>
            <div class="text">
              {{ dataSource[key].desc.value }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataSource: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      showMore: false,
      music: null,
      playKey: ""
    };
  },
  methods: {
    handleShowMore() {
      this.showMore = true;
    },
    handlePlay(key) {
      if (this.music && this.playKey === key) {
        this.playKey = "";
        this.music.pause();
        this.music = null;
      } else {
        if (this.music) {
          this.music.pause();
          this.music = null;
        }
        this.playKey = key;
        this.music = new Audio(this.dataSource[key].source.value);
        this.music.play();
        this.music.loop = false;
        this.music.addEventListener("ended", () => {
          this.playKey = "";
          this.music = null;
        });
      }
    }
  }
};
</script>

<style lang="less" scoped>
.voices {
  position: relative;
  width: 100%;
  padding-top: 16px;
  .list {
    width: 100%;
    height: 288px;
    overflow-y: auto;
    overflow-x: hidden;
    /* 滚动槽 */
    &::-webkit-scrollbar {
      width: 4px;
      height: 5px;
    }
    &::-webkit-scrollbar-track {
      border-radius: 2px;
      background: rgba(255, 255, 255, 0.1);
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.08);
    }
    /* 滚动条滑块 */
    &::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background: #95cde7;
      -webkit-box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.2);
    }
  }
  .item-box {
    margin-bottom: 12px;
    &:last-child {
      margin-bottom: 0;
    }
  }
  .voices-item {
    display: flex;
    align-items: center;
    .icon {
      width: 24px;
      height: 24px;
      margin-right: 12px;
      img {
        width: 100%;
      }
    }
    .info {
      .name {
        font-weight: 400;
        font-size: 12px;
        color: #95cde7;
        line-height: 20px;
        margin-bottom: 4px;
      }
      .text {
        font-weight: 400;
        font-size: 12px;
        color: #999999;
        line-height: 16px;
      }
    }
  }

  .show-more {
    position: absolute;
    bottom: 0px;
    left: 0;
    width: 100%;
    padding: 0 0 9px;
    text-align: center;
    img {
      width: 12px;
      height: 12px;
    }
  }
}
</style>
